<template>
  <AddPicking />
</template>

<script>
import AddPicking from '@/components/PICKING/AddPicking.vue';

export default {
  name: 'AddPickingView',
  components: {
    AddPicking,
  },
}
</script>
